<script lang="ts">
  // Single-value ring gauge (inline SVG). Shows a fraction 0..1 as a filled arc
  // with the percentage in the center.
  let {
    value,
    size = 120,
    stroke = 12,
    color = 'var(--color-primary)',
    track = 'color-mix(in oklab, var(--color-base-content) 12%, transparent)',
    center = '',
    sub = '',
  }: {
    value: number;
    size?: number;
    stroke?: number;
    color?: string;
    track?: string;
    center?: string;
    sub?: string;
  } = $props();

  const r = $derived((size - stroke) / 2);
  const circ = $derived(2 * Math.PI * r);
  const clamped = $derived(Math.max(0, Math.min(1, value)));
  const dash = $derived(`${(clamped * circ).toFixed(2)} ${circ.toFixed(2)}`);
  const c = $derived(size / 2);
</script>

<div class="relative inline-flex items-center justify-center" style="width: {size}px; height: {size}px">
  <svg width={size} height={size} viewBox="0 0 {size} {size}" role="img" aria-label="{center} {sub}">
    <circle cx={c} cy={c} r={r} fill="none" stroke={track} stroke-width={stroke} />
    <circle
      cx={c}
      cy={c}
      r={r}
      fill="none"
      stroke={color}
      stroke-width={stroke}
      stroke-linecap="round"
      stroke-dasharray={dash}
      transform="rotate(-90 {c} {c})"
    />
  </svg>
  <div class="absolute flex flex-col items-center leading-none">
    <span class="font-display text-xl font-bold tabular-nums">{center}</span>
    {#if sub}<span class="mt-0.5 font-mono text-[0.6rem] text-base-content/68">{sub}</span>{/if}
  </div>
</div>
